import { useEffect, useRef, useState } from "react";
import { DEFAULT_LESSON_MINUTES } from "@/constants/ui";

export function useTimer({ minutes = DEFAULT_LESSON_MINUTES, isRunning = true, resetKey }) {
  const [timerState, setTimerState] = useState({ resetKey, secondsLeft: minutes * 60 });
  const intervalRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (!isRunning) return undefined;
    intervalRef.current = window.setInterval(() => {
      setTimerState((previousTimerState) => {
        if (previousTimerState.resetKey !== resetKey) return { resetKey, secondsLeft: minutes * 60 };
        return { resetKey, secondsLeft: Math.max(0, previousTimerState.secondsLeft - 1) };
      });
    }, 1000);
    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [intervalRef, isRunning, minutes, resetKey, setTimerState]);

  const secondsLeft = timerState.resetKey === resetKey ? timerState.secondsLeft : minutes * 60;
  const minutesLeft = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
  const secondsDisplay = String(secondsLeft % 60).padStart(2, "0");
  return { secondsLeft, minutesLeft, secondsDisplay };
}